/**
 * @desc 更新
 */
const URL = "/rantion-report";
import http, { updateResponse } from "@/http";
export function request(body: defs.report.ImportTaskRecordCreateRpcRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/importTaskRecord/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
